module.exports = __webpack_public_path__ + "media/src/images/mails/twitter-e3fb1119a758e25af1d205315f269104.png";